import styled from 'styled-components'

export const Button = styled.button`
	display: inline-block;
	background-color: transparent;
	color: inherit;
	touch-action: manipulation;

	padding: 0;
	border: 0;

	text-align: left;

	cursor: pointer;

	&:focus,
	&:hover,
	&:active {
		outline: 0;
		text-decoration: none;
	}

	&:disabled {
		cursor: default;
	}
`
